export type PermissionLevel = 'none' | 'view' | 'edit' | 'admin';

export const PERMISSION_LEVEL_ORDER: PermissionLevel[] = ['none', 'view', 'edit', 'admin'];

export function levelRank(level: PermissionLevel): number {
  return PERMISSION_LEVEL_ORDER.indexOf(level);
}

export function maxLevel(a: PermissionLevel, b: PermissionLevel): PermissionLevel {
  return levelRank(a) >= levelRank(b) ? a : b;
}

export function isValidLevel(value: any): value is PermissionLevel {
  return PERMISSION_LEVEL_ORDER.includes(value);
}

export interface PermissionCatalogItem {
  key: string;
  labelKey: string;
  descriptionKey: string;
  category: string;
  levels: PermissionLevel[];
  dangerous?: boolean;
}

export interface PermissionSummary {
  byCategory: Record<string, { atEditOrAbove: number; atViewOrAbove: number; total: number }>;
}

export interface BusinessPermissionProfile {
  _id?: string;
  businessId: string;
  targetType: 'user' | 'department';
  targetId: string;
  grants: Record<string, PermissionLevel>;
  updatedBy?: string;
}
